const configManageRouter = {
  path: "/config",
  name: "配置",
  meta: { title: "配置", icon: "el-icon-setting" },
  redirect: "/config/autoLayout",
  component: () => import("../../views/configManage/index"),
  children: [
    {
      path: "/config/autoLayout",
      name: "AutoLayout",
      meta: { title: "AutoLayout" },
      redirect: "/config/autoLayout/list",
      component: () => import("../../views/configManage/autoLayout/index"),
      children: [
        {
          path: "/config/autoLayout/list",
          name: "资源列表",
          hidden: true,
          meta: { activePath: "/config/autoLayout", title: "资源列表" },
          component: () =>
            import("../../views/configManage/autoLayout/list")
        },
        {
          path: "/config/autoLayout/create",
          name: "新建资源",
          hidden: true,
          meta: { activePath: "/config/autoLayout", title: "新建资源" },
          component: () =>
            import("../../views/configManage/autoLayout/createOrEdit")
        },
        {
          path: "/config/autoLayout/edit/:id",
          name: "编辑资源",
          hidden: true,
          meta: { activePath: "/config/autoLayout", title: "编辑资源" },
          component: () =>
            import("../../views/configManage/autoLayout/createOrEdit")
        },
        {
          path: "/config/autoLayout/info/:id",
          name: "查看资源",
          hidden: true,
          meta: { activePath: "/config/autoLayout", title: "查看资源" },
          component: () =>
            import("../../views/configManage/autoLayout/info")
        }
      ]
    },
    {
      path: "/config/aiStyle",
      name: "AIStyle",
      meta: { title: "AIStyle" },
      redirect: "/config/aiStyle/list",
      component: () => import("../../views/configManage/aiStyle/index"),
      children: [
        {
          path: "/config/aiStyle/list",
          name: "资源列表",
          hidden: true,
          meta: { activePath: "/config/aiStyle", title: "资源列表" },
          component: () =>
            import("../../views/configManage/aiStyle/list")
        },
        {
          path: "/config/aiStyle/create",
          name: "新建资源",
          hidden: true,
          meta: { activePath: "/config/aiStyle", title: "新建资源" },
          component: () =>
            import("../../views/configManage/aiStyle/createOrEdit")
        },
        {
          path: "/config/aiStyle/edit/:id",
          name: "编辑资源",
          hidden: true,
          meta: { activePath: "/config/aiStyle", title: "编辑资源" },
          component: () =>
            import("../../views/configManage/aiStyle/createOrEdit")
        },
      ]
    },
    {
      path: "/config/iosAppInfo",
      name: "IOS应用信息",
      meta: { title: "IOS应用信息" },
      redirect: "/config/iosAppInfo/list",
      component: () => import("../../views/configManage/iosAppInfo/index"),
      children: [
        {
          path: "/config/iosAppInfo/list",
          name: "资源列表",
          hidden: true,
          meta: { activePath: "/config/iosAppInfo", title: "资源列表" },
          component: () =>
            import("../../views/configManage/iosAppInfo/list")
        },
        {
          path: "/config/iosAppInfo/create",
          name: "新建资源",
          hidden: true,
          meta: { activePath: "/config/iosAppInfo", title: "新建资源" },
          component: () =>
            import("../../views/configManage/iosAppInfo/createOrEdit")
        },
        {
          path: "/config/iosAppInfo/edit/:id",
          name: "编辑资源",
          hidden: true,
          meta: { activePath: "/config/iosAppInfo", title: "编辑资源" },
          component: () =>
            import("../../views/configManage/iosAppInfo/createOrEdit")
        },
      ]
    },
    {
      path: "/config/remoteConfig",
      name: "应用配置下发",
      meta: { title: "应用配置下发" },
      redirect: "/config/remoteConfig/list",
      component: () => import("../../views/configManage/remoteConfig/index"),
      children: [
        {
          path: "/config/remoteConfig/list",
          name: "资源列表",
          hidden: true,
          meta: { activePath: "/config/remoteConfig", title: "资源列表" },
          component: () =>
            import("../../views/configManage/remoteConfig/list")
        },
        {
          path: "/config/remoteConfig/create",
          name: "新建资源",
          hidden: true,
          meta: { activePath: "/config/remoteConfig", title: "新建资源" },
          component: () =>
            import("../../views/configManage/remoteConfig/createOrEdit")
        },
        {
          path: "/config/remoteConfig/edit/:id",
          name: "编辑资源",
          hidden: true,
          meta: { activePath: "/config/remoteConfig", title: "编辑资源" },
          component: () =>
            import("../../views/configManage/remoteConfig/createOrEdit")
        },
      ]
    },
  ]
};
export default configManageRouter;